import React, { useState, useEffect } from "react";
import CustomCarousel from "../../Carousel";
import StepOne from "../../Carousel/StepOne";
import StepTwo from "../../Carousel/StepTwo";
import StepThree from "../../Carousel/StepThree";

import LogoBlue from "../../../../../../assets/images/advancly-logo.png";
import styles from "./LandingLayout.module.scss";

interface ILandingLayout {
  bgColor?: string;
  onClose?: () => void;
  onBack?: () => void;
  showBackButton?: boolean;
  children?: React.ReactNode;
  showCarousel?: boolean;
  currentStep?: string;
}

const LandingLayout: React.FC<ILandingLayout> = ({
  children,
  bgColor = "background-white",
  onClose,
  onBack,
  showBackButton = false,
  showCarousel = true,
  currentStep = "",
}) => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    // Calculate progress based on current step
    // This can be enhanced based on your actual flow
    if (currentStep) {
      const steps = [
        "business-type",
        "directors-info",
        "documents",
        "review",
        "complete",
      ];
      const currentIndex = steps.indexOf(currentStep);
      if (currentIndex !== -1) {
        setProgress(((currentIndex + 1) / steps.length) * 100);
      }
    } else {
      setProgress(10);
    }
  }, [currentStep]);

  const renderView = () => {
    if (!showCarousel) {
      return <div className={styles.welcomeScreen}>{children}</div>;
    }

    return (
      <main role="main" className={styles.main}>
        <div className={styles.left}>
          {showBackButton && onBack && (
            <button
              type="button"
              onClick={onBack}
              className={styles.backButton}
            >
              <i className="fas fa-chevron-left"></i> Go back
            </button>
          )}
          <div className={styles.content}>{children}</div>
        </div>
        <div className={styles.right}>
          <div className={styles.SliderContainer}>
            <CustomCarousel>
              <StepOne />
              <StepTwo />
              <StepThree />
            </CustomCarousel>
          </div>
        </div>
      </main>
    );
  };

  return (
    <div className={`${styles.landingLayout} ${bgColor}`}>
      <div
        className={styles.onBoardingProgressBar}
        style={{ width: `${progress}%` }}
      ></div>
      <div className={styles.header}>
        <img
          className={styles.logoWhiteBgc}
          src={LogoBlue}
          alt="Advancly Logo"
        />
        {onClose && (
          <button
            onClick={onClose}
            className={styles.closeButton}
            aria-label="Close"
          >
            <i className="fa fa-times"></i>
          </button>
        )}
      </div>

      <>{renderView()}</>
    </div>
  );
};

export default LandingLayout;
